export default __webpack_public_path__ + "static/media/code_blue.b0cad406.mp3";